export const comments_3357254 = {"data":{"data":[],"links":{}}}